import { BREAKPOINTS, useWindowSize } from 'sarsaparilla';

export default function useLayoutSize() {
    const { width } = useWindowSize();

    let layoutSize = 'xs'
    if(width >= BREAKPOINTS.xxl) {
        layoutSize = 'xxl'
    } else if(width >= BREAKPOINTS.xl) {
        layoutSize = 'xl'
    } else if(width >= BREAKPOINTS.lg) {
        layoutSize = 'lg'
    } else if(width >= BREAKPOINTS.md) {
        layoutSize = 'md'
    } else if(width >= BREAKPOINTS.sm) {
        layoutSize = 'sm'
    }
    
    return layoutSize;
}
